
import Swal from 'sweetalert2';

export const catchError = (error,navigate) => {
    
    if (error.status == 403 ) {
        localStorage.removeItem("@first_name");
        localStorage.removeItem("@last_name");
        localStorage.removeItem("@user_role");
        localStorage.removeItem("@user_email");
        Swal.fire({ icon: "error", title: "Session Expired", text: error.message });
        navigate("/login");
    }
    else {
        Swal.fire({ icon: "error", title: "Request Denied", text: error.message });
    }
}

